<script>
import Page from '@/components/elements/Page';
export default {
    name: 'InternationalQRCode',
    components: {
        Page
    },
    computed: {
        currentLanguage() {
            return this.$store.state.languages.current;
        }
    },
    created() {
        document.title = 'Information in your vaccination QR-Code';
    }
}
</script>

<template>
    <Page class="home" :displayBackButton=false>
        <div class="section">
            <div class="section-block" style="width:450px;" >
                <h2>Information in your vaccination QR-Code</h2>
                <p>
                    <ul style="margin-left: 40px;">
                    <li>(a) surname, first name(s) and date of birth;</li>
                    <li>(c) disease targeted: COVID-19</li>
                    <li>(d) vaccine medicinal product, vaccine and vaccine manufacturer</li>
                    <li>(g) Number in series of doses/ total number of doses</li>
                    <li>(h) date of vaccination</li>
                    <li>(i) Member State in which vaccination was carried out</li>
                    <li>(j) Certificate issuer and certificate code</li>
                    </ul>
                </p>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.home {

    .home__section {
        margin-bottom: $length-l;
    }

    .UserConsent {
        margin: $grid-x6 0 $length-s 0;
    }

    .ErrorLabel {
        margin-bottom: $length-s;
    }
}
</style>
